import DebugUANC from '../../../core/version/debug';
import { PLUGIN_NAME } from '../config';
import { iwaAddEvent } from '../../iwa-add-event';

const statusMapping: { [key: string]: string } = {
    '5': '4',
    '6': '1',
    '7': '4',
    '8': '2',
    '9': '3',
};

/**
 * Ustala status RODO.
 * Wykorzystuje i nasłuchuje rodoAPI dla ustalenia statusu.
 *
 * @returns {Promise<string>} bieżący status RODO
 */
const getRodoKeyword = async (): Promise<string> => {
    const rodoKeyword = '4';
    const { rodoAPI } = window;
    if (!rodoAPI) return rodoKeyword;

    try {
        if (rodoAPI.getStatus() === '0') {
            return new Promise((resolve) => {
                rodoAPI.onHide(() => {
                    if (rodoAPI.getStatus() != '0') {
                        resolve(statusMapping[rodoAPI.getStatus()] ?? rodoAPI.getStatus());
                    }
                    resolve(rodoKeyword);
                });
            });
        } else {
            return statusMapping[rodoAPI.getStatus()] ?? rodoAPI.getStatus();
        }
    } catch (e) {
        throw new Error(`Problem with receiving the status. ${e}`);
    }
};

/**
 * Inicjuje plugin RODO.
 * Wykorzystuje rodoAPI oraz tcfAPI
 *
 * @returns {Promise<PLUGIN_NAME | Error>} Nazwa załadowanego pluginu lub w przypadku problemów przekazanie informacja o błędzie.
 */
export const processRodoKeyword = async (): Promise<PLUGIN_NAME | Error> => {
    const { Ad } = window.Inpl;

    try {
        const rodoKeyword = await getRodoKeyword();
        iwaAddEvent('trackEvent', 'rodo', 'status', `${Ad.detection?.host}`, `${rodoKeyword}`);

        Ad.plugins = {
            ...Ad.plugins,
            [PLUGIN_NAME.RODO_KEYWORD]: {
                isEnabled: true,
                keywords: [rodoKeyword],
            },
        };

        if (Ad.UANC instanceof DebugUANC) {
            Ad.UANC.info('Plugin RodoKeyword', `has been successfully embedded. Keywords: ${rodoKeyword}`);
        }
        return PLUGIN_NAME.RODO_KEYWORD;
    } catch (e) {
        throw new Error(`[RodoKeyword] - problem loading the plugin. ${e}`);
    }
};
